import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Button,
    Divider
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import ChildForm from './ChildForm';

const ChildrenSection = () => {
    const { control } = useFormContext();

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'children'
    });

    const addChild = () => {
        const newChild = {
            firstName: '',
            middleName: '',
            lastName: '',
            birthDate: '',
            residesWith: '',
            supportNeeded: false
        };
        append(newChild);
    };

    const removeChild = (index) => {
        remove(index);
    };

    return (
        <Paper elevation={1} sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6">
                    Children ({fields.length})
                </Typography>
                <Button
                    type="button"
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={addChild}
                >
                    Add Child
                </Button>
            </Box>

            {fields.length === 0 ? (
                <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'center', py: 4 }}>
                    No children added yet. Click "Add Child" to get started.
                </Typography>
            ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                    {fields.map((field, index) => (
                        <Box key={field.id}>
                            <ChildForm
                                index={index}
                                onRemove={() => removeChild(index)}
                            />
                            {index < fields.length - 1 && <Divider sx={{ mt: 2 }} />}
                        </Box>
                    ))}
                </Box>
            )}
        </Paper>
    );
};

export default ChildrenSection;